import {RequestMessage} from '@map/core';

export const hideSpinnerMessageTag = 'HideSpinnerMessage';

/**
 * Hide the SecureBrowser's spinner.
 */
export class HideSpinnerMessage extends RequestMessage {
  readonly tag: string = hideSpinnerMessageTag;
}
